import { InputText } from 'primereact/inputtext';
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown';

import styles from './Filters.module.scss';
import { IFiltersProps } from './IFiltersProps';
import { useCookies } from 'react-cookie';

const Filters = ({
	divisionsOptions,
	yearsOptions,
	quartersOptions,
	statusOptions,
	firstNameFilter,
	setFirstNameFilter,
	lastNameFilter,
	setLastNameFilter,
	emailFilter,
	setEmailFilter,
	divisionFilter,
	setDivisionFilter,
	yearFilter,
	setYearFilter,
	quarterFilter,
	setQuarterFilter,
	statusFilter,
	setStatusFilter
}: IFiltersProps): JSX.Element => {
	const [cookies, setCookie] = useCookies([
		'notificationLogsDivision',
		'notificationLogsYear',
		'notificationLogsQuarter',
		'notificationLogsStatus'
	]);

	const handleDivisionChange = (value: string | number) => {
		setDivisionFilter(value);
		setCookie('notificationLogsDivision', value);
	};

	const handleYearChange = (value: number | null) => {
		setYearFilter(value);
		if (value) {
			setCookie('notificationLogsYear', value.toString());
		}
	};

	const handleQuarterChange = (value: number | null) => {
		setQuarterFilter(value);
		if (value) {
			setCookie('notificationLogsQuarter', value.toString());
		}
	};

	const handleStatusChange = (value: number | null) => {
		setStatusFilter(value);
		if (value) {
			setCookie('notificationLogsStatus', value.toString());
		}
	};

	return (
		<div className={styles.container}>
			<InputText
				className={styles.filter}
				placeholder="Email"
				value={emailFilter}
				onChange={(e) => setEmailFilter(e.target.value)}
			/>
			<Dropdown
				showClear
				className={styles.filter}
				placeholder="Division"
				value={divisionFilter}
				options={divisionsOptions}
				onChange={(e: DropdownChangeParams) => handleDivisionChange(e.target.value)}
			/>
			<Dropdown
				showClear
				className={styles.filter}
				placeholder="Year"
				value={yearFilter}
				options={yearsOptions}
				onChange={(e: DropdownChangeParams) => handleYearChange(e.target.value)}
			/>
			<Dropdown
				showClear
				className={styles.filter}
				placeholder="Quarter"
				value={quarterFilter}
				options={quartersOptions}
				onChange={(e: DropdownChangeParams) => handleQuarterChange(e.target.value)}
			/>
			<Dropdown
				showClear
				className={styles.filter}
				placeholder="Status"
				value={statusFilter}
				options={statusOptions}
				onChange={(e: DropdownChangeParams) => handleStatusChange(e.target.value)}
			/>
		</div>
	);
};

export default Filters;
